import { Injectable } from '@angular/core';
import { CountriesQuery, CountryType } from '@generated/graphql';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountryApi {
  constructor (
    private countriesQuery: CountriesQuery,
  ) {
  }

  get$ (): Observable<CountryType[]> {
    return this.countriesQuery.watch(undefined, {
      fetchPolicy: 'no-cache',
    }).valueChanges.pipe(
      map(res => res.data.countries as CountryType[]),
    );
  }
}
